import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { useAlert } from 'react-alert';
import withClass from '../../../hoc/withClass';
import errorHandler from '../../../hoc/ErrorHandler';
import { RANDOM_STRING } from '../../../constants';
import eBoardLogo from '../../../assets/images/eboard-logo.png';
import SystemCopyright from '../../../components/UI/SystemCopyright/SystemCopyright';
import Credentials from './Forms/Credentials/Credentials';
import NewPassword from './Forms/NewPassword/NewPassword';
import './ForgotPassword.css';

const ForgotPassword = props => {
    document.body.className = "page-forgot-password layout-full";

    const [userEmail, setUserEmail] = useState(null);
    const [companyCode, setCompanyCode] = useState(null);
    const [OTP, setOTP] = useState(null);
    const [password, setPassword] = useState(null);
    const [passwordChanged, setPasswordChanged] = useState(false);

    const alert = useAlert();

    const testflight = async credentials => {
        const response = await axios.post(`/auth/test-flight`, credentials);
        if(response) {
            setUserEmail(credentials.email);
            setCompanyCode(credentials.code);
            setOTP(RANDOM_STRING(6).toUpperCase());
        }
    };

    useEffect(() => {
        const resetPassword = async () => {
            const response = await axios.post('/auth/reset-password-otp', {
                code: companyCode, 
                username: userEmail, 
                otp: OTP
            });

            if(response) {
                window.$('#changePassword').modal('show');
                return alert.show(response.data.message, {type: 'success'});
            }
        }

        if(OTP) 
            resetPassword();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [OTP]);

    const changePasswordHandler = async credentials => {
        if(credentials.otp !== OTP) 
            return alert.show('Invalid OTP', {type: 'error'});

        const response = await axios.patch(`/auth/reset-password`, {
            ...credentials, 
            password: password,
            username: userEmail, 
            code: companyCode
        });
        
        if(response) {
            setUserEmail(null);
            setCompanyCode(null);
            setOTP(null);
            setPasswordChanged(true);

            return alert.show(response.data.message, {type: 'success'});
        }
    };

    const userPasswordInputChangeHandler = (password, isValid) => {
        if(!isValid) 
            return setPassword(null);

        if(password.length === 0) 
            return setPassword(null);

        return setPassword(password);
    };

    return (
        <Fragment>
            <div className="page-content vertical-align-middle">
                <img src={eBoardLogo} alt="eBoard Logo" className="img-fluid mx-auto d-block" style={{width: '200px', height: '70px'}} /> 
                <h2>Forgot Your Password?</h2>
                <p>Provide your registered email and code to reset your password</p>
                <Fragment>
                    <Credentials 
                        testflight={testflight}
                        userEmail={userEmail}
                        companyCode={companyCode}
                        passwordChanged={passwordChanged}
                    />
                    <NewPassword changePasswordHandler={changePasswordHandler} userPasswordInputChangeHandler={userPasswordInputChangeHandler} password={password} />
                    <SystemCopyright forgotPassword />
                </Fragment>
            </div>
        </Fragment>
    );
};

export default errorHandler(withClass(ForgotPassword, 'page vertical-align text-center'), axios);